export default import.meta.ROLLDOWN_FILE_URL_LvPqR9zafrtYtBG$CdltiA